import React from 'react'
import { PureComponent } from 'react';
import { Status } from '../application/Status';
import CoreUtils from '../common/utils/CoreUtils';
import DomUtils from '../common/utils/DomUtils';
import SessionApi from '../api-services/SessionApi';

const tokenExpiryCheckPeriodMs = 3000;

export default class TableauView extends PureComponent {
  constructor(props) {
		super(props);

		this.tableauVizRef = React.createRef();

		this.script = document.createElement("script");

		this.parentContainerElement = DomUtils.getElementItemByClassName('pwx-main-container');
		this.resizeObserver = new ResizeObserver(() => requestAnimationFrame(() => this.updateViewSize()));

		this.tokenExpiryCheckListener = this.tokenExpiryCheckCallback.bind(this);

		this.activeToken = null;
		this.tableauTokenExpiryUtc = null;
		this.serverUtcTimeOffsetMs = 0;
		this.tokenExpiryCheck = null;
	}

	componentDidMount() {
		this.resizeObserver.observe(this.parentContainerElement);

		this.script.src = this.props.script;
		this.script.type = 'module';
		document.head.appendChild(this.script);

		this.loadTableauToken();
		this.updateViewSize();
	}

	componentWillUnmount() {
		this.cancelTokenExpiryCheck();

		document.head.removeChild(this.script);

		this.resizeObserver.disconnect();
		this.resizeObserver = null;
		this.parentContainerElement = null;
	}

	async refreshTableauToken() {
		var authorizationDto = await SessionApi.getTableauAuthorization(this.props.counterpartyCode);

		this.activeToken = authorizationDto.tableauToken;
		this.tableauTokenExpiryUtc = Date.parse(authorizationDto.tableauTokenExpiryUtc);
		this.serverUtcTimeOffsetMs = Date.parse(authorizationDto.tableauCurrentTimeUtc) - Date.now();

		this.tokenExpiryCheck = setInterval(this.tokenExpiryCheckListener, tokenExpiryCheckPeriodMs);
	}

	cancelTokenExpiryCheck() {
		if (CoreUtils.isUndefinedOrNull(this.tokenExpiryCheck))
			return;

		clearInterval(this.tokenExpiryCheck);
		this.tokenExpiryCheck = null;
	}

	tokenExpiryCheckCallback() {
		var serverUtcTimeMs = Date.now() + this.serverUtcTimeOffsetMs;
		if (serverUtcTimeMs < this.tableauTokenExpiryUtc - tokenExpiryCheckPeriodMs)
			return;

		this.cancelTokenExpiryCheck();
		this.refreshTableauToken();
	}

	async loadTableauToken() {
		await this.refreshTableauToken();
		this.forceUpdate();
	}

	updateViewSize() {
		if (this.parentContainerElement === null)
			return;

		var containerSize = DomUtils.calculateInnerContentSize(
			DomUtils.getElementItemByClassName('pwx-tableau-view-container')
		);

		DomUtils.setElementSize(
			DomUtils.getElementItemByClassName('tableau-container'),
			containerSize
		);

		DomUtils.setElementSize(
			document.getElementById('tableau-viz'),
			containerSize
		);

		if (CoreUtils.isDefinedAndNotNull(this.tableauVizRef.current))
			this.tableauVizRef.current.setFrameSize(containerSize.width, containerSize.height);
	}

	render() {
		var containerSizeStyle = DomUtils.calculateInnerContentSizeStyle(
			DomUtils.getElementItemByClassName('pwx-tableau-view-container')
		);

		if (CoreUtils.isUndefinedOrNull(this.activeToken))
			return <Status statusContent="Loading..." />
		else
			return (
				<div
					className="tableau-container"
					style={containerSizeStyle}
				>
					<tableau-viz
						id="tableau-viz"
						ref={this.tableauVizRef}
						src={this.props.url}
						token={this.activeToken}
						toolbar="hidden"
						style={containerSizeStyle}
					/>
				</div>
				)
  }
}